import { Component, OnInit, ViewChild } from "@angular/core";
import { DriverService } from "../shared/driver.service";
import { Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { LgtGridStaticComponent } from "@app/shared/components/lgt-grid-static/lgt-grid-static.component";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-drivers-list",
  templateUrl: "./drivers-list.component.html",
  styleUrls: ["./drivers-list.component.css"],
})
export class DriversListComponent implements OnInit {
  @ViewChild(LgtGridStaticComponent, { static: false }) gridComponent: LgtGridStaticComponent;

  tripList: any = [];

  cols: any[];
  filters = {
    driverNo: "",
    lastName: "",
    name: "",
    cellPhone: "",
    peopleNetId: "",
    type: "",
    email: "",
    isActive: "",
    hiredDate: "",
    canDispatch: "",
    inCompliance: "",
    lessorName: "",
  };

  selectAllTrips: any = false;
  isSelectAllClicked: any = false;
  rowsfilterQuantity: any = 0;
  printfilterQuantity: any = 0;
  XLSX: any;

  errorMsg: any;

  newButtonAction: any = this.onClickNew;
  newButtonOptions: any = [
    {
      label: "New Driver",
      command: () => {
        this.onClickNew();
      },
    },
  ];

  constructor(
    private _driverList: DriverService,
    private router: Router,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit() {
    this.cols = [
      { field: "driverNo", header: "Id" },
      { field: "lastName", header: "Last Name" },
      { field: "name", header: "Name" },
      { field: "cellPhone", header: "Phone Number" },
      { field: "peopleNetId", header: "PeopleNet ID" },
      { field: "type", header: "Driver Type" },
      { field: "email", header: "Email" },
      { field: "isActive", header: "Active", type: "boolean" },
      { field: "hiredDate", header: "Hired Date", type: "date" },
      { field: "canDispatch", header: "Can Dispatch", type: "boolean" },
      { field: "inCompliance", header: "In Compliance", type: "boolean" },
      { field: "lessorName", header: "Lessor" },
    ];

    this.selectAllTrips = false;
    this.isSelectAllClicked = false;
    this.rowsfilterQuantity = 0;
    this.printfilterQuantity = 0;
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this._AuthService.hasPermission(permission);
  }

  viewDetail = (driver: any) => {
    if (this.featureFlagsService.isEnabled('useNewDriverPages')) {
      this.router.navigate(["/drivers/", driver.id]);
    } else {
      this.router.navigate(["/driverinfo/", driver.id]);
    }
  }

  loadData() {
    return this._driverList.getDriverListGrid();
  }

  onClickNew() {
    this.router.navigate(["/newdriver"]);
  }

  excelGeneration(selectedColumns: any[], selectedTrips: any[], filters: any, selectAll: boolean) {
    const colNames = selectedColumns.map((col) => col.header);
    const colFields = selectedColumns.map((col) => col.field);

    const observable = this._driverList.getExportDrivers(selectedTrips, filters, selectAll);
    observable.subscribe((res: any) => {
      const values = res.map((trip) => ({
        ...trip,
        hiredDate: trip.hiredDate ? new Date(trip.hiredDate).toLocaleDateString() : null,
      }));

      let plainRecords = values.map((trip) => {
        let tripRecord = [];
        for (const field of colFields) {
          const datatype = typeof trip[field];
          if (datatype === "string")
            trip[field] = trip[field].replace(/\r?\n|\r/g, "").toUpperCase();
          if (trip[field] && trip[field].toString().includes(",")) {
            tripRecord.push(`"${trip[field]}"`);
          } else {
            tripRecord.push(trip[field] || "");
          }
        }
        return tripRecord;
      });
      plainRecords.unshift(colNames);
      let CsvString = "";
      for (const rowItem of plainRecords) {
        CsvString += rowItem.join(",") + "\r\n";
      }
      CsvString = "data:application/csv," + encodeURIComponent(CsvString);
      let x = document.createElement("A");
      x.setAttribute("href", CsvString);
      x.setAttribute("download", "drivers_" + new Date().toLocaleDateString() + ".csv");
      document.body.appendChild(x);
      x.click();
    });
  }
}
